/**
 * The heavy media of the booking intro: clips, a photo and the music. None of it is committed.
 *
 * Each value is an https URL (the render box: upload through POST /api/social/media and pass the
 * urls in the `media` prop) or a path in the public dir. The defaults point into the gitignored
 * public/featureintro/media folder, so a local render works once that folder is filled.
 */
export type BookingMedia = {
	/** Hook cut 1, "Guest houses" */
	bungalows: string;
	/** Hook cut 2, "Treehouses" */
	treehouse: string;
	/** Hook cut 3, "Resorts" */
	jungle: string;
	/** Hook cut 4, "Hotels" */
	boutique: string;
	/** Hook cut 5, "Apartments", and Bangkok's card on the map */
	pool: string;
	/** Chiang Mai's card on the map and the second half of the Chiang Mai portal */
	doiSuthep: string;
	/** The first half of the Chiang Mai portal */
	monks: string;
	/** Pai's card on the map (a photo) */
	pai: string;
	/**
	 * The music: the full Villa Penthouse mp3 (Mixkit), 1:43. The composition cuts and fades it: it
	 * starts at BOOKING_MUSIC_FROM and fades out over the film's last 3 s.
	 */
	music: string;
};

/** Where the film's music starts in the full Villa Penthouse track, in seconds */
export const BOOKING_MUSIC_FROM = 17.248;

export const BOOKING_MEDIA: BookingMedia = {
	bungalows: "featureintro/media/s-bungalows.mp4",
	treehouse: "featureintro/media/s-treehouse.mp4",
	jungle: "featureintro/media/s-jungle.mp4",
	boutique: "featureintro/media/s-boutique.mp4",
	pool: "featureintro/media/pool.mp4",
	doiSuthep: "featureintro/media/doisuthep-s.mp4",
	monks: "featureintro/media/h-monks.mp4",
	pai: "featureintro/media/pai0.jpg",
	music: "featureintro/media/villa-penthouse.mp3",
};
